Monitoring.Views ||= {}
class Monitoring.Views.SocialContentNotesView extends Backbone.View
  template: JST["backbone/templates/monitoring/social_contents/notes"]

  events:
    'keyup #new-note': 'updateAddNoteButton'
    'click #notes-btn-add': 'addNote'

  initialize: (@options = {}) ->
    @contentId = @options.contentId

  show: ->
    @_renderModal()
    @_loadNotes()

  addNotes: (notes) =>
    container = @$el.find('.notes-container')
    container.html(@template({ notes: notes })).removeClass('processing')
    for note in notes
      noteView = new Monitoring.Views.SocialContentNoteView({ note: note })
      @$el.find('.notes-container').append(noteView.render().$el)
      @listenTo(noteView, 'decrementCounter', => @trigger('decrementCounter'))
    setTimeout( ->
      container.scrollTop(container[0].scrollHeight)
    , 100)

  updateAddNoteButton: =>
    textarea = @$el.find('#new-note')
    addNoteButton = @$el.find('#notes-btn-add')[0]
    addNoteButton.disabled = textarea.val().trim().length == 0

  addNote: =>
    $.ajax
      type: 'POST',
      url: '/monitoring/dashboard/notes?content_id=' + @contentId
      data:
        note_text: @$el.find('#new-note').val()
      success: (response) =>
        @trigger('notes:created:success')
      error: =>
        showError('An unexpected error has occurred trying to create note')
    @$el.find('#new-note').val('')

  _renderModal: ->
    @$el.modal()
    @$el.find('.notes-container').html('').addClass('processing')
    setTimeout =>
      @$el.find('#new-note').focus()
    , 500

  _loadNotes: ->
    $.get('/monitoring/dashboard/notes?content_id=' + @contentId, (response) =>
      if response.notes
        @notes = response.notes
        @addNotes(@notes)
    )
